export default "__VITE_ASSET__DfEbVlw2__"